import * as yup from 'yup';
import { VALID_DATE, VALID_EMAIL } from 'constants/text';

/** Empty picker value must validate as cleared, not as an invalid date. */
const nullablePickerDate = () =>
  yup
    .date()
    .nullable()
    .transform((value, originalValue) =>
      value === '' || originalValue === '' ? null : value,
    )
    .typeError(VALID_DATE);

export const schema = yup.object({
  currentPartner: yup.string().nullable(),
  businessName: yup
    .string()
    .nullable()
    .transform((value) => value?.trim() || null),
  revenueShare: yup.number().nullable(),
  address: yup.string().nullable(),
  city: yup.string().nullable(),
  state: yup.string().nullable(),
  zip: yup.string().nullable(),
  timeZone: yup.string().nullable(),
  contractSignedDate: nullablePickerDate(),
  supportLiveDate: nullablePickerDate(),
  marketingLaunchDate: nullablePickerDate(),
  litsDate: nullablePickerDate(),
  membershipSalesCalendlyLink: yup.string().nullable(),
  membershipUrlNew: yup.string().nullable(),
  membershipUrlComNew: yup.string().nullable(),
  websiteUrl: yup.string().nullable(),
  zendeskUrl: yup.string().nullable(),
  zendeskDomain: yup.string().nullable(),
  slackTeamLink: yup.string().nullable(),
  dosCalendly: yup.string().nullable(),
  billingEmail: yup.string().email(VALID_EMAIL).nullable(),
  billingEmail2: yup.string().email(VALID_EMAIL).nullable(),
  buyNow: yup.string().nullable(),
  annual: yup.boolean().nullable(),
  notionBoardUrl: yup.string().nullable(),
  docsendUrl: yup.string().nullable(),
  stripeAccountId: yup.string().nullable(),
  stripeCustomerId: yup.string().nullable(),
  iterableTestUserId: yup.string().nullable(),
  globalNotificationEmail: yup.string().email(VALID_EMAIL).nullable(),
});
